/**
 * Validate of Phone number.
 * @string
 */
export const PhoneNumberValidate = (phone: string): boolean => {
  if (!phone || phone === '') {
    return true;
  }
  return (
    phone.split('')[0] === '7' && phone.split('').length === 11
  );
};

/**
 * Validate of Email.
 * @string
 */
export const EmailStringValidate = (): string => {
  return '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$';
};

/**
 * Validate of file types.
 * @param file
 * @boolean
 */
export const FileIsImageValidate = (file: File): boolean => {
  const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

  return file && acceptedImageTypes.includes(file['type']);
};


/**
 * Validate of VK link.
 * Accepts vk.com/... and vkvideo.ru/... (e.g. https://vkvideo.ru/video-19083451_456241202).
 * @param link
 * @boolean
 */
export const VKLinkValidate = (link: string): boolean => {
  if (!link || typeof link !== 'string') return false;
  const trimmed = link.trim();
  const vkComRegex = /^(https?:\/\/)?(www\.)?vk\.com\/(id\d|[a-zA-Z0-9_.])+$/;
  const vkVideoRegex = /^(https?:\/\/)?(www\.)?vkvideo\.ru\/[a-zA-Z0-9_.\-]+$/;
  return vkComRegex.test(trimmed) || vkVideoRegex.test(trimmed);
};


/**
 * Validate of Facebook link.
 * @param link
 * @boolean
 */
export const FBLinkValidate = (link: string): boolean => {
  const regex = /(?:(?:http|https):\/\/)?(?:www.)?facebook.com|fb.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/gm;

  let error = false;
  let id = null;

  while ((id = regex.exec(link)) !== null) {
    if (id.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    error = true;
  }

  return error;
};


/**
 * Validate of Instagram link.
 * @param link
 * @boolean
 */
export const INSTLinkValidate = (link: string): boolean => {
  const regex = /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/;

  return regex.test(link);
};


/**
 * Validate of SoundCloud link.
 * @param link
 * @boolean
 */
export const SoundCloudLinkValidate = (link: string): boolean => {
  const regex = /^https?:\/\/(soundcloud\.com|snd\.sc)\/(.*)$/;

  return !!link.match(regex) && !!link.match(regex)[2];
};


/**
 * Validate of Instagram link.
 * @param link
 * @boolean
 */
export const URLLinkValidate = (link: string): boolean => {
  const regex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm;

  return regex.test(link);
};


/**
 * Validate of Youtube link.
 * @param link
 * @boolean
 */
export const YTLinkValidate = (link: string): boolean => {
  const regex = '^(http(s)?:\\/\\/)?((w){3}.)?youtu(be|.be)?(\\.com)?\\/.+';
  let error = true;

  if (link.search('^(http(s)?:\\/\\/)?((w){3}.)?youtu(be|.be)?(\\.com)?\\/.+') !== 0) {
    error = false;
  }
  return error;
};

/**
 * Slug: 3–100 chars, only lowercase latin, digits, hyphens.
 */
export const SlugValidate = (slug: string): boolean => {
  if (!slug || typeof slug !== 'string') return false;
  const regex = /^[a-z0-9][a-z0-9-]{1,98}[a-z0-9]$/;
  return regex.test(slug);
};

/**
 * Validates that the string is a VK video link (vk.com/video..., vk.com/video_ext... or vkvideo.ru/video-...).
 */
export const VKVideoLinkValidate = (link: string): boolean => {
  if (!link || link.trim() === '') return true;
  const trimmed = link.trim();
  const vkComRegex = /^(https?:\/\/)?(www\.)?vk\.com\/(video|video_ext)(\d+_\d+)(\?.*)?$/i;
  const vkVideoRuRegex = /^(https?:\/\/)?(www\.)?vkvideo\.ru\/video-\d+_\d+(\?.*)?$/i;
  return vkComRegex.test(trimmed) || vkVideoRuRegex.test(trimmed);
};

/**
 * Validates that the string is a VK playlist/audio link (vk.com/audio or vk.com/music).
 */
export const VKPlaylistLinkValidate = (link: string): boolean => {
  if (!link || link.trim() === '') return true;
  const regex = /^(https?:\/\/)?(www\.)?vk\.com\/(audio|music)(\?.*)?/i;
  return regex.test(link.trim());
};

/**
 * Single hashtag: 3–20 символов включительно, латинские буквы/цифры/подчёркивание, # в начале необязателен.
 */
export const HashtagValidate = (tag: string): boolean => {
  if (!tag || typeof tag !== 'string') return false;
  const s = tag.trim().replace(/^#+/, '');
  if (s.length < 3 || s.length > 20) return false;
  return /^[a-zA-Z0-9_]+$/.test(s);
};

/**
 * Hashtags string or array: up to 10 tags, each 3–20 chars.
 */
export const HashtagsListValidate = (value: string[]): boolean => {
  if (!value || value.length > 10) return false;
  return value.every(tag => HashtagValidate(tag));
};
